const SCHEDULE_INVALID_RANGE = "La date de début doit être antérieure ou égale à la date de fin.";

export function toIsoUtcZ(localDatetime) {
    if (!localDatetime) return null;
    const d = new Date(localDatetime);
    if (Number.isNaN(d.getTime())) return null;
    return d.toISOString().replace(/\.\d{3}Z$/, "Z");
}

export function fromIsoUtcToDatetimeLocal(iso) {
    if (!iso) return "";
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return "";
    const pad = (n) => String(n).padStart(2, "0");
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export function formatScheduleDate(iso) {
    const d = iso instanceof Date ? iso : new Date(iso);
    if (Number.isNaN(d.getTime())) return "";
    return d.toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" });
}

export function validateRuleScheduleRange(validFromLocal, validUntilLocal) {
    if (!validFromLocal || !validUntilLocal) return null;
    const from = new Date(validFromLocal);
    const until = new Date(validUntilLocal);
    if (Number.isNaN(from.getTime()) || Number.isNaN(until.getTime())) return null;
    if (from.getTime() > until.getTime()) return SCHEDULE_INVALID_RANGE;
    return null;
}

/**
 * @param {string} validFromLocal datetime-local
 * @param {string} validUntilLocal datetime-local
 * @param {{ includeNulls?: boolean }} [opts] includeNulls=true en PATCH pour pouvoir vider la plage
 */
export function buildRuleSchedulePayload(validFromLocal, validUntilLocal, { includeNulls = false } = {}) {
    const valid_from = toIsoUtcZ(validFromLocal);
    const valid_until = toIsoUtcZ(validUntilLocal);
    if (!includeNulls && !valid_from && !valid_until) return {};
    return {
        valid_from: valid_from || null,
        valid_until: valid_until || null,
    };
}

export function describeRuleSchedule(rule, now = new Date()) {
    const starts = rule?.valid_from ? new Date(rule.valid_from) : null;
    const ends = rule?.valid_until ? new Date(rule.valid_until) : null;
    const startOk = starts && !Number.isNaN(starts.getTime());
    const endOk = ends && !Number.isNaN(ends.getTime());

    let label = "Permanente";
    if (startOk && endOk) label = `${formatScheduleDate(starts)} → ${formatScheduleDate(ends)}`;
    else if (startOk) label = `À partir du ${formatScheduleDate(starts)}`;
    else if (endOk) label = `Jusqu'au ${formatScheduleDate(ends)}`;

    let badge = null;
    if (endOk && now > ends) badge = { key: "expired", text: "Expirée" };
    else if (startOk && now < starts) badge = { key: "scheduled", text: "Programmée" };
    else if (startOk || endOk) badge = { key: "promo", text: "Promo active" };

    return { label, badge, starts: startOk ? starts : null, ends: endOk ? ends : null };
}

export const RULE_SCHEDULE_BADGE_SX = {
    expired: { bgcolor: "#f1f5f9", color: "#475569" },
    scheduled: { bgcolor: "#eef2ff", color: "#4338ca" },
    promo: { bgcolor: "#fff7ed", color: "#c2410c" },
};
